import React from 'react';
import { connect } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import fetch from '../hooks/fetch';
import FacetSidebar from './FacetSidebar';
import FacetDropdowns from './FacetDropdowns';
import SearchBanner from './SearchBanner';
import SearchResults from './SearchResults';
import SearchInfo from '../components/SearchInfo';
import SearchInput from './SearchInput';
import SearchPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/SearchPanelContainer';

const SearchPanelFull = ({
  canRun,
  category,
  code,
  description,
  exists,
  fetchData,
  fetchSearch,
  fetchSearchConfig,
  isDirty,
  isNew,
  name,
  onChange,
  readErrors,
  readStatus,
  searchConfigStatus,
  search,
  filtersVisible,
  setFiltersVisible,
  url,
}) => {
  fetch.useSearch(
    fetchData,
    fetchSearchConfig,
    fetchSearch,
    category,
    code,
    readStatus,
    searchConfigStatus,
    search,
    isNew,
    filtersVisible,
    setFiltersVisible,
  );

  return (
    <SearchPanelContainer
      canRun={canRun}
      category={category}
      code={code}
      description={description}
      exists={exists}
      isDirty={isDirty}
      isNew={isNew}
      name={name}
      onChange={onChange}
      readErrors={readErrors}
      readStatus={readStatus}
      url={url}
    >
      <div className="aridhia-search-panel-full">
        <Grid container padded="vertically">
          <Grid.Row centered stretched>
            <Grid.Column width={16} centered>
              <div className="sticky-panel-header">
                <SearchInput code={code} category={category} />
                <SearchInfo />
                <SearchBanner code={code} category={category} />
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row centered stretched>
            <FacetDropdowns
              code={code}
              category={category}
            />
          </Grid.Row>
          <Grid.Row divided>
            <Grid.Column width={4}>
              <FacetSidebar
                code={code}
                category={category}
              />
            </Grid.Column>
            <Grid.Column width={12}>
              <SearchResults code={code} category={category} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    </SearchPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchPanelFull);
